const colors = {
  primary: '#619cf8',
  secondary: '#f9d266',
  accent: '#f9d266',
  gray: '#f5f7fd',
  light: {
    bg: '#f5f9ff',
    card: '#FFF',
    slider: 'rgba(100, 100, 100, .25)',
    text: '#151515',
  },
  dark: {
    bg: '#1b1b27',
    card: '#33354e',
    slider: 'rgba(100, 100, 100, .15)',
    text: '#fcfcfc',
  },
}

export const gradients = {
  primary: `linear-gradient(to right, ${colors.primary}, ${colors.secondary})`,
}

export default colors
